import React from 'react';
import { StyledCopyright } from './styles';
import moment from 'moment';
const Copyright = props => {
  const {
    name,
    trade,
    rights,
    message
  } = props;
  const year = moment().year();
  const defaultRights = `all rights reserved${!message ? '.' : ''}`;
  const hasMessage = message?.length > 0;
  return /*#__PURE__*/React.createElement(StyledCopyright, null, trade && /*#__PURE__*/React.createElement("span", null, "\xAE & "), "\xA9", year, name && ` ${name}`, rights && `, ${defaultRights}`, hasMessage && ` — ${message}`);
};
export { Copyright };